// Loads the CRM 2.0 facts for one booking on the Home card (M2-F9).
// Reloads when the booking's status changes (Home's realtime listener updates it) and every
// minute while we wait for the Relationship Manager, so the CRM shows up without a reload.
// Old-flow bookings: no call, returns null.
import { useCallback, useEffect, useState } from "react";
import { getCrm2Booking } from "../../../Services/Crm2Booking";

export const WAITRM = "Waiting to assign your dedicated Relationship Manager";
const POLL_MS = 60 * 1000;

export default function useCrm2Booking(allotment) {
	const apId = allotment?.isCrm2 ? allotment?.allotmentPaymentId : null;
	const [info, setInfo] = useState(null);

	const load = useCallback(() => {
		if (!apId) return;
		getCrm2Booking(apId)
			.then((data) => setInfo(data?.isCrm2 ? data : null))
			.catch((err) => console.warn("[crm2][portal] booking info not loaded", apId, err.message));
	}, [apId]);

	useEffect(() => {
		if (!apId) {
			setInfo(null);
			return;
		}
		load();
	}, [apId, allotment?.status, load]);

	useEffect(() => {
		if (info?.bookingState !== "WAITING_RM") return;
		const id = setInterval(load, POLL_MS);
		return () => clearInterval(id);
	}, [info?.bookingState, load]);

	return info;
}
